import { render } from "./ExternalApiEditForm.vue?vue&type=template&id=5d2a4b95"
import script from "./ExternalApiEditForm.vue?vue&type=script&lang=js"
export * from "./ExternalApiEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__